export default __webpack_public_path__ + "static/media/Detail-HCIS.5f107273.png";